import {
  HandballAttributeId,
  HandballEventStatusId,
  HandballIncidentId,
} from '@collector/sportsapi-client-legacy'

import { DetailsPanelSportConfiguration } from '../DetailsPanelSportConfigurationFactory'
import {
  HandballAttributesConfiguration,
  HandballDetailsConfiguration,
  HandballGroupNames,
} from './HandballDetailsConfiguration'
import {
  HandballDetailsIncidentIds,
  HandballHideIncidentIds,
  HandballParticipantIncidentIds,
  HandballSecondParticipantIncidentIds,
} from './HandballFiltersIncidentIds'
import { HandballManualAddIncidentIds } from './HandballManualAddIncidentIds'
import { HandballManualAddStatusIds } from './HandballManualAddStatusIds'

export const HandballConfiguration: DetailsPanelSportConfiguration<
  HandballIncidentId,
  HandballAttributeId,
  HandballEventStatusId
> = {
  groupNames: HandballGroupNames,
  detailsConfiguration: HandballDetailsConfiguration,
  attributesConfiguration: HandballAttributesConfiguration,
  secondParticipantIncidents: HandballSecondParticipantIncidentIds,
  filters: {
    hideIncidents: HandballHideIncidentIds,
    participantIncidents: HandballParticipantIncidentIds,
    detailsIncidents: HandballDetailsIncidentIds,
    selectedOnStartDetailsIncidents: HandballDetailsIncidentIds,
  },
  manualAddIncidentModal: {
    statuses: HandballManualAddStatusIds,
    incidents: HandballManualAddIncidentIds,
    substitutionIncidents: [],
  },
}
